import { DocumentConstants } from "../types/DocumentConstants";
let initialState = {
  all: [],
  pending:[],
  active:[],
  isAssignedSuccessfully:false,
  docSubmittedSuccessfully:false,
  isCancelledSuccessfully :false,
  documentDetails : {}
};
export function document(state = initialState, action) {
  switch (action.type) {
    case DocumentConstants.ASSIGN_DOC_PATIENT_REQUEST: {
      state.isAssignedSuccessfully = false;
      return state;
    }
    case DocumentConstants.ASSIGN_DOC_PATIENT_SUCCESS: {
      state.isAssignedSuccessfully = true;
      return state;
    }case DocumentConstants.GET_ALL_DOC_REQUEST: {
      state.isAssignedSuccessfully = false;
      state.isCancelledSuccessfully=false;
      state.docSubmittedSuccessfully=false;
      state.documentDetails = {};
      state.all = [];
      state.pending = [];
      state.active = [];
      return state;
    }case DocumentConstants.GET_ALL_DOC_SUCCESS: {
      state.all = action.data;
      return state;
    }case DocumentConstants.GET_ACTIVE_DOC_REQUEST: {
      state.isAssignedSuccessfully = false;
      state.isCancelledSuccessfully=false;
      state.docSubmittedSuccessfully=false;
      state.documentDetails = {};
      state.all = [];
      state.pending = [];
      state.active = [];
      return state;
    }case DocumentConstants.GET_ACTIVE_DOC_SUCCESS: {
      state.active = action.data;
      return state;
    }case DocumentConstants.GET_PENDING_DOC_REQUEST: {
      state.isAssignedSuccessfully = false;
      state.isCancelledSuccessfully=false;
      state.docSubmittedSuccessfully=false;
      state.documentDetails = {};
      state.all = [];
      state.pending = [];
      state.active = [];
      return state;
    }case DocumentConstants.GET_PENDING_DOC_SUCCESS: {
      state.pending = action.data;
      return state;
    }case DocumentConstants.SUBMIT_DOC_REQUEST: {
      state.isAssignedSuccessfully = false;
      state.isCancelledSuccessfully=false;
      state.docSubmittedSuccessfully=false;
      state.all = [];
      state.pending = [];
      state.active = [];
      return state;
    }case DocumentConstants.SUBMIT_DOC_SUCCESS: {
      state.docSubmittedSuccessfully=true;
      return state;
    }case DocumentConstants.CANCEL_DOC_REQUEST: {
      state.isAssignedSuccessfully = false;
      state.isCancelledSuccessfully=false;
      state.docSubmittedSuccessfully=false;
      state.documentDetails = {};
      state.all = [];
      state.pending = [];
      state.active = [];
      return state;
    }case DocumentConstants.CANCEL_DOC_SUCCESS: {
      state.isCancelledSuccessfully=true;
      return state;
    }case DocumentConstants.GET_DOC_BY_ID_REQUEST: {
      state.isAssignedSuccessfully = false;
      state.isCancelledSuccessfully=false;
      state.docSubmittedSuccessfully=false;
      state.documentDetails = {};
      state.all = [];
      state.pending = [];
      state.active = [];
      return state;
    }case DocumentConstants.CLEAR_ALL_DOCUMENT_DETAILS: {
      state.isAssignedSuccessfully = false;
      state.isCancelledSuccessfully=false;
      state.docSubmittedSuccessfully=false;
      state.documentDetails = {};
      state.all = [];
      state.pending = [];
      state.active = [];
      return state;
    }
    case DocumentConstants.GET_DOC_BY_ID_SUCCESS: {
      state.docSubmittedSuccessfully = false;
      state.documentDetails = action.data;
      return state;
    }default:
      return state;
  }
}
